module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "paraf"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ABOUT THE AUTHOR")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Alastair McKay grew up in North Berwick. He has written for "), _c('em', [_vm._v("Uncut")]), _vm._v(" magazine, the "), _c('em', [_vm._v("Evening Standard")]), _vm._v(", "), _c('em', [_vm._v("NME")]), _vm._v(", "), _c('em', [_vm._v("The Scotsman")]), _vm._v(", "), _c('em', [_vm._v("Scotland on Sunday")]), _vm._v(", "), _c('em', [_vm._v("The Sunday Times")]), _vm._v(", "), _c('em', [_vm._v("The Guardian")]), _vm._v(", "), _c('em', [_vm._v("Black Book")]), _vm._v(", "), _c('em', [_vm._v("Out")]), _vm._v(", "), _c('em', [_vm._v("Blah Blah Blah")]), _vm._v(" and "), _c('em', [_vm._v("The Independent")]), _vm._v(". He lives in London with his partner, his spirited daughter and a lazy cat.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06e1940b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm01.vue
// module id = 60
// module chunks = 0